import { create } from 'zustand';

const useSettingLayoutStore = create((set) => ({
  isOpen: false,
  setIsOpen: (isOpen) => set({ isOpen }),
  toggleIsOpen: (isOpen) => set({ isOpen: !isOpen }),
}));

export default useSettingLayoutStore;
